<template>
  <div class="mapcontainer h-full">
    <div class="form-panel">
      <j-search-select-tag
        :dictOptions="devOptions"
        @change="selectDev"
        placeholder="搜索设备名称、编号"
        style="width: 300px"
        v-model="filter.devId"
      />
      <a-button @click="getDevList" icon="reload" style="margin-left: 8px" />
      <j-multi-select-tag
        @change="displayMarker"
        dictCode="device_run_status"
        placeholder="请选择"
        type="checkbox"
        v-model="filter.runStatus"
      ></j-multi-select-tag>
    </div>
    <div id="container"></div>

    <device-control-modal ref="devControlModal"></device-control-modal>
  </div>
</template>
  <script>
  import { getAction, postAction } from '@/api/manage'
  import moment from 'dayjs'
  import DeviceControlModal from './modules/DeviceControlModal'
  import AMapLoader from "@amap/amap-jsapi-loader";

  const runstatusStyles = {
    free: {
      image: '/static/image/wf_marker_free.png', // 标注点图片url或base64地址
      size: [35, 35],
      anchor: 'top-center',
      textStyle: {
        fontSize: 16,
        fillColor: '#52c41a',
        strokeColor: '#fff', // 标注点文本描边颜色
        strokeWidth: 2, // 标注点文本描边宽度
      },
    },
    busy: {
      size: [35, 35],
      anchor: 'top-center',
      image: '/static/image/wf_marker_busy.png', // 标注点图片url或base64地址
      textStyle: {
        fontSize: 16,
        fillColor: '#faad14',
        strokeColor: '#fff', // 标注点文本描边颜色
        strokeWidth: 2, // 标注点文本描边宽度
      },
    },
    alert: {
      size: [35, 35],
      anchor: 'top-center',
      image: '/static/image/wf_marker_alert.png', // 标注点图片url或base64地址
      color: '#9e9e9e', // 标注点文本颜色
      textStyle: {
        fontSize: 16,
        fillColor: '#9e9e9e',
        strokeColor: '#fff', // 标注点文本描边颜色
        strokeWidth: 2, // 标注点文本描边宽度
      },
    },
    unAvailable: {
      size: [35, 35],
      anchor: 'top-center',
      image: '/static/image/wf_marker_unavail.png', // 标注点图片url或base64地址
      color: '#d3ae0b', // 标注点文本颜色
      textStyle: {
        fontSize: 16,
        fillColor: '#d3ae0b',
        strokeColor: '#fff', // 标注点文本描边颜色
        strokeWidth: 2, // 标注点文本描边宽度
      },
    }
  }

  export default {
    name: 'DevListMap',
    components: {
      DeviceControlModal
    },
    data () {
      return {
        map: null,
        filter: {
          runStatus: 'free,busy,alert'
        },
        devices: [],
        devOptions: [],
        devMarkers: [],
        url: {
          list: '/device/devList/list',
          corpList: '/device/devList/corpList',
          devdetail: 'device/devList/queryWfDetail',
        },
      };
    },
    computed: {
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    mounted () {
      // 调用
      this.initMap();
    },
    unmounted () {
      this.map?.destroy();
    },
    methods: {
      initMap () {
        var that = this;
        AMapLoader.load({
          key: "8a49abe3ca517db0c0aa58c3c41f8a92", // 申请好的Web端开发者Key，首次调用 load 时必填
          version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then((AMap) => {
          this.AMap = AMap;
          let map = new AMap.Map("container", {
            // 设置地图容器id
            viewMode: "3D", // 是否为3D地图模式
            zoom: 11, // 初始化地图级别
            center: [116.397428, 39.90923], // 初始化地图中心点位置
          });
          this.map = map;

          map.on('complete', function () {
            that.locate();

            // 创建 AMap.LabelsLayer 图层
            var layer = new AMap.LabelsLayer({
              zooms: [3, 20],
              zIndex: 1000,
              collision: false
            });
            that.layer = layer;
            // 将图层添加到地图
            map.add(layer);
            //获取设备
            that.getDevList();

            //初始化infoWindow
            var infoWindow = new AMap.InfoWindow({
              anchor: "bottom-center",
            });
            infoWindow.close();//初始关闭信息窗关闭
            that.infoWindow = infoWindow;
          });
        }).catch((e) => {
          console.log(e);
        });

      },
      getDevList () {
        var that = this;
        let listUrl = this.userInfo.thirdAccount ? this.url.corpList : this.url.list;

        getAction(listUrl, { checkAvail: true, pageSize: 999999 }).then((res) => {
          if (res.success) {
            this.devices = res.result.records
            this.devOptions = [];
            const markers = [];

            //清空图层  
            this.layer.remove(this.devMarkers)

            res.result.records.forEach(device => {
              this.devOptions.push({
                value: device.id,
                text: device.devName
              });
              let style = runstatusStyles[device.runStatus];
              //如果不是故障状态，优先显示不可用
              if (device.runStatus !== 'alert' && !device.ifAvailable) {
                style = runstatusStyles['unAvailable'];
              }
              var icon = {
                type: 'image',
                image: style.image,
                size: style.size,
                anchor: style.anchor,
              };
              //@date 2024年11月18日17:49:01， 地图marker不显示名称
              if (device.coordinateGcj02) {
                const coordinateGcj02 = device.coordinateGcj02.replace('，', ',').split(',');
                var curData = {
                  name: device.devName,
                  position: coordinateGcj02,
                  icon,
                  extData: device,
                  text: {
                    content: device.ifAvailable ? '启用' : '停用',
                    style: {
                      fontSize: 16, //字体大小
                      fillColor: device.ifAvailable ? '#52c41a' : '#9e9e9e', //字体颜色
                      strokeColor: "#fff", //描边颜色
                      strokeWidth: 2, //描边宽度
                    },
                  }
                };
                curData.extData = device;
                var labelMarker = new AMap.LabelMarker(curData);
                markers.push(labelMarker);
                labelMarker.on('click', function (e) {
                  var position = e.data.data && e.data.data.position;
                  var bizId = e.data.data.extData?.id || e.target._opts.extData?.id
                  console.log(e);
                  that.clickMarker(position, bizId);
                });
              }
            });

            // 一次性将海量点添加到图层
            this.layer.add(markers);
            this.devMarkers.splice(0, this.devMarkers.length, ...markers);
          } else {
            this.$message.error(res.message)
          }
        })
      },
      selectDev (id) {
        if (!id) {
          return;
        }
        const that = this;
        this.devMarkers.forEach(marker => {
          if (marker._opts.extData.id === id) {
            if (that.filter.runStatus.includes(marker._opts.extData.runStatus)) {
              that.map.setCenter(marker._opts.position)
              that.clickMarker(marker._opts.position, id)
            } else {
              that.$message.warning('此设备已被隐藏，请勾选设备状态显示')
            }

          }
        });
      },
      async clickMarker (position, geometryId) {
        const that = this;
        //设置infoWindow
        this.infoWindow.open(this.map, position); //打开信息窗
        const device = this.devices.find(dev => dev.id === geometryId)
        const pictureObjId = device.pictureObjId;
        const picSrc = pictureObjId ? pictureObjId.split(',')[0] : ''

        const devDetail = await this.getDevDetail(geometryId);
        const availHours = devDetail.availHours || [];

        let contentHtml = `<div id="infoWindow" class="pop-container">
                <div class="pop-title" title="${device.devName}">${device.devName}</div>
                <span class="pop-tag tag-${device.runStatus}">${device.runStatus_dictText}</span>
                <span class="pop-tag tag-${device.ifAvailable ? 'free' : 'alert'}">${device.ifAvailable ? '启用' : '停用'}</span>
                <p>名称：${device.devName}</p>
                <p>地址：${device.location}</p>
                <span>运行时间：</span>`;
        if (availHours.length === 0) {
          contentHtml += `<span class="pop-tag">00:00~24:00</span>`;
        } else {
          availHours.forEach(hour => {
            contentHtml += `<span class="pop-tag">${hour.startTime}~${hour.endTime}</span>`;
          });
        }
        if (picSrc) {
          contentHtml += `<img class="pop-pic" src='${picSrc}' alt="设备照片">`
        }

        const lastConsumerRecord = devDetail.lastConsumerRecord || {};

        if (lastConsumerRecord.id) {
          if (lastConsumerRecord.endTime) {
            contentHtml += `<span>${lastConsumerRecord.endTime} 上次加水结束</span>`;
          } else {
            contentHtml += `<span>${lastConsumerRecord.startTime} 正在加水</span>`;
          }
          contentHtml += '<div style="margin-top: 10px"></div>'
          if (this.userInfo.thirdAccount) {
            contentHtml += `<p><span class="blue-vertical-line"></span>班组：${lastConsumerRecord.groupId_dictText}</p>
                            <p><span class="blue-vertical-line"></span>取水人：${lastConsumerRecord.consumerUserId_dictText}</p>`;
          } else {
            contentHtml += `<p><span class="blue-vertical-line"></span>企业：${lastConsumerRecord.corpId_dictText}</p>
                            <p><span class="blue-vertical-line"></span>班组：${lastConsumerRecord.groupId_dictText}</p>
                            <p><span class="blue-vertical-line"></span>取水人：${lastConsumerRecord.consumerUserId_dictText}</p>`;
          }
        }

        if (!this.userInfo.thirdAccount) {
          contentHtml += `<div class="pop-footer">
                        <div class="pop-btn" data-biz="dev-detail">设备详情</div>
                        <div class="pop-btn" data-biz="dev-control">设备控制</div>
                    </div>
                </div>`
        }


        this.infoWindow.setContent(contentHtml);//设置信息窗内容

        const infoWindowDom = document.getElementById('infoWindow');
        infoWindowDom.addEventListener('click', function (evt) {
          if (evt.target.className.includes('pop-btn')) {
            if (evt.target.dataset.biz === 'dev-detail') {
              //设备详情
              that.handleDetail(device)
            } else if (evt.target.dataset.biz === 'dev-control') {
              //设备控制
              that.handleControl(device)
            }
          }
        });
      },
      async getDevDetail (id) {
        const res = await getAction(this.url.devdetail, { id });
        if (res.success) {
          return res.result;
        }
        return {}
      },
      displayMarker (status) {
        this.devMarkers.forEach(marker => {
          if (!status.includes(marker._opts.extData.runStatus)) {
            marker.hide();
          } else {
            marker.show();
          }
        });
      },
      handleControl (record) {
        this.$refs.devControlModal.edit({ id: record.id })
        this.$refs.devControlModal.title = `设备控制-【${record.devName}】`
      },
      handleDetail (record) {
        this.$bus.$emit('to-page-detail', {
          name: 'FusionDevice',
          id: record.id,
          type: 'drawer'
        })
      },
      locate () {
        var that = this;
        navigator.geolocation.getCurrentPosition(function (position) {
          var latitude = position.coords.latitude;  // 获取纬度
          var longitude = position.coords.longitude;  // 获取经度
          var position = new AMap.LngLat(longitude, latitude); //传入经纬度
          that.map.setCenter(position);
        });
      },
    }
  }

  </script>
 <style>

  .mapcontainer {
    margin: 0 5px;
    overflow: hidden;
  }

  .form-panel {
    width: 400px;
    position: absolute;
    z-index: 2;
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
  }

  #container {
    width: 100%;
    height: 100%;
  }

  .pop-container {
    width: 300px;
    padding: 5px;
    text-align: left;
  }

  .pop-container p {
    width: 100%;
    text-wrap: wrap;
    word-wrap: break-word;
    margin: 0.5em 0;
  }

  .pop-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pop-pic {
    width: 100%;
    margin-bottom: 10px;
  }

  .pop-footer {
    margin-top: 10px;
    text-align: center;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }

  .pop-tag {
    box-sizing: border-box;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum';
    display: inline-block;
    height: auto;
    margin: 0 8px 0 0;
    padding: 2px 10px;
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
    background: #fafafa;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: default;
    opacity: 1;
    transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  }

  .blue-vertical-line {
    display: inline-block;
    width: 3px;
    height: 14px;
    background-color: #1890ff;
    margin-right: 8px;
    vertical-align: middle;
  }

  span.tag-free {
    color: #52c41a;
    background: #f6ffed;
    border-color: #b7eb8f;
  }

  span.tag-busy {
    color: #fa8c16;
    background: #fff7e6;
    border-color: #ffd591;
  }
  span.tag-alert {
    color: #fff;
    background: #9e9e9e;
    border-color: #b8b8b8;
  }

  .pop-btn {
    padding: 5px 10px;
    margin-right: 10px;
    background-color: #007bff;
    color: white;
    text-decoration: none;
    cursor: pointer;
  }

  .pop-btn:hover {
    background-color: #0056b3;
  }

</style>
<style  lang="less" scoped>
  /* antd样式覆盖 */
  /deep/ .ant-drawer {
    z-index: 1001 !important;
  }
</style>